/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography2, breakpoints } from '@coursera/cds-core';

import { getHeadingStyle } from 'bundles/unified-description-page-common/components/modules/product-overview/details/Details';
import Modal from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import type { ModalProps } from 'bundles/unified-description-page-common/components/shared/modals/Modal';
import { useXDPRedesignPhase1Data } from 'bundles/unified-description-page-common/providers/specialization/XDPRedesignPhase1Provider';
import { getLanguageString } from 'bundles/unified-description-page-common/utils/languages';

import _t from 'i18n!nls/xdp';

const styles = {
  paragraph: css`
    margin-bottom: var(--cds-spacing-100);
  `,
  button: css`
    ${breakpoints.down('xs')} {
      width: 100%;
      max-width: none;
    }
  `,
};

type Props = ModalProps & {
  primaryLanguages: string[];
  subtitleLanguages?: string[] | null;
};

const LanguagesDetailItemModal = ({ primaryLanguages, subtitleLanguages, ...rest }: Props) => {
  const { enableXDPRedesignPhase1, enableXDPRedesignDescriptionRework } = useXDPRedesignPhase1Data();
  const enableXDPRedesign = enableXDPRedesignPhase1 || enableXDPRedesignDescriptionRework;

  return (
    <Modal {...rest} header={_t('Languages')}>
      <Typography2 variant={getHeadingStyle(enableXDPRedesign)} component="p" css={styles.paragraph}>
        <FormattedMessage
          message={_t('Available in {primaryLanguages}')}
          primaryLanguages={getLanguageString(primaryLanguages)}
        />
      </Typography2>
      {subtitleLanguages && (
        <Typography2 component="p" variant="bodyPrimary">
          <FormattedMessage
            message={_t('Subtitles: {subtitleLanguages}')}
            subtitleLanguages={getLanguageString(subtitleLanguages)}
          />
        </Typography2>
      )}
    </Modal>
  );
};

export default LanguagesDetailItemModal;
